"use client";

import { ParallaxCard } from "politicamente-informados-ds";

interface IAttrs {
    text: string;
    backgroundColor: string;
    color?: string;
    repeatLines: number;
    repeatContent: number;
    rotateDeg?: number | undefined;
    duration: number;
    className?: string | undefined;
    contrastColor?: string;
    contrastEnabled?: boolean;
}

export type IBlockMarquee = {
    attrs: IAttrs;
};

export default function BlockParallaxe({
    attrs,
}: {
    attrs: Record<string, any>;
}) {
    const {
        className,
        backgroundColor,
        imageUrl,
        position = "center",
        width = "100%",
        message,
        messageSize,
        messageSizeMobile,
        messageColor,
        contrastColor = "#ffffff",
        contrastEnabled = false
    } = attrs || {};

    return (
        <ParallaxCard
            imageElement={
                <img
                    src={imageUrl}
                    alt="Description"
                    width={width}
                    height="100%"
                    sizes="100vw"
                    decoding="async"
                />
            }
            maskColor={backgroundColor ?? ""}
            maskPos={position}
            message={message}
            messageSize={messageSize}
            messageSizeMobile={messageSizeMobile}
            messageColor={messageColor}
            contrastEnabled={contrastEnabled}
            contrastColor={contrastColor}
        />
    );
}
